import React from 'react';
import {
  Alert,
  Sheet,
  IconButton,
  ArrowLeftIcon,
  Button,
  HeadingText,
  CaptionText,
} from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import UpdateView from './updates/UpdateView';
import { Message } from '@paypalcorp/worldready-react';
import { ORGANIZER_UPDATES } from '../../utility/constants';
import { getWorldReady } from '../../utility/worldReadyUtils';
import { MessageFormat } from '@paypalcorp/worldready';
import OrganizerUpdatesList from './OrganizerUpdateList';
import {
  trackUpdatesDetailDismissPressed,
  trackUpdatesListDismissPressed,
} from '../../fpti/fpti';

const OrganizerUpdatesSheet = ({
  closeSheet,
  isSheetOpen,
  action,
  totalUpdatesCount,
  selectedUpdate = {},
  organizerUpdates,
  handleUpdatePreviewCardClick,
  handleBackButtonClick,
  showBackButton,
  renderShowMoreUpdatesLink,
  hideSheetTitle,
  isLoading,
  setCurrentUpdate,
  showLikeError,
  setShowLikeError,
  showLoading,
  isListError,
  fetchOrganizerUpdates,
  fetchNextUpdates,
}) => {
  const getOrganizerUpdatesContent = (route, params) => {
    return new MessageFormat(getWorldReady(), {
      id: `common.organizerUpdates.${route}`,
    }).format(params);
  };

  const handleCloseSheet = (reason) => {
    switch (action) {
      case ORGANIZER_UPDATES.ACTIONS.SHOW_UPDATE_LIST:
        trackUpdatesListDismissPressed(reason);
        break;
      case ORGANIZER_UPDATES.ACTIONS.SHOW_UPDATE_DETAIL_VIEW:
        trackUpdatesDetailDismissPressed(reason, selectedUpdate.fou_id);
        break;
      default:
        break;
    }
    return true;
  };

  const organizerComponentRender = () => {
    switch (action) {
      case ORGANIZER_UPDATES.ACTIONS.SHOW_UPDATE_DETAIL_VIEW:
        return (
          <div data-testid="updates-detailed-view">
            {selectedUpdate && (
              <UpdateView
                update={selectedUpdate}
                id={selectedUpdate.fou_id}
                setCurrentUpdate={setCurrentUpdate}
                setShowLikeError={setShowLikeError}
                showLoading={showLoading}
                fromUpdatesDetailedView={true}
              />
            )}
          </div>
        );
      case ORGANIZER_UPDATES.ACTIONS.SHOW_UPDATE_LIST:
        return (
          <OrganizerUpdatesList
            organizerUpdates={organizerUpdates}
            handleUpdatePreviewCardClick={handleUpdatePreviewCardClick}
            renderShowMoreUpdatesLink={renderShowMoreUpdatesLink}
            isLoading={isLoading}
            getOrganizerUpdatesContent={getOrganizerUpdatesContent}
            setShowLikeError={setShowLikeError}
            setCurrentUpdate={setCurrentUpdate}
            isListError={isListError}
            fetchNextUpdates={fetchNextUpdates}
          />
        );
      case ORGANIZER_UPDATES.ACTIONS.ORGANIZER_UPDATE_SINGLE_UPDATE_ERROR:
        return (
          <div className="text-center">
            <HeadingText className="fetch-update-error-title">
              <Message id="common.genericError.error.update.load" />
            </HeadingText>
            <CaptionText className="fetch-update-error-subtitle">
              <Message id="landing.campaigns.contributions.error.body" />
            </CaptionText>
            <Button
              onClick={fetchOrganizerUpdates}
              btnState={showLoading ? 'processing' : 'initial'}
            >
              <Message id="landing.campaigns.contributions.error.cta" />
            </Button>
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    isSheetOpen && (
      <Sheet
        title={getOrganizerUpdatesContent('updates.title', {
          totalUpdatesCount: totalUpdatesCount,
        })}
        hideTitle={hideSheetTitle}
        isOpen={isSheetOpen}
        onClose={closeSheet}
        onBeforeClose={handleCloseSheet}
        data-testid="organizer-update-sheet"
        skipFormFocus={true}
        action={
          showBackButton && (
            <IconButton
              svgIconComponent={ArrowLeftIcon}
              buttonType="tertiary"
              onClick={handleBackButtonClick}
            />
          )
        }
      >
        {showLikeError && (
          <Alert type="warning" className="organizer-like-error">
            <Message id="common.genericError.error.update.likeButton" />
          </Alert>
        )}
        {organizerComponentRender()}
      </Sheet>
    )
  );
};

OrganizerUpdatesSheet.propTypes = {
  closeSheet: PropTypes.func,
  isSheetOpen: PropTypes.bool,
  action: PropTypes.string,
  totalUpdatesCount: PropTypes.number,
  selectedUpdate: PropTypes.object,
  organizerUpdates: PropTypes.array,
  handleUpdatePreviewCardClick: PropTypes.func,
  handleBackButtonClick: PropTypes.func,
  showBackButton: PropTypes.bool,
  handleShowMoreUpdates: PropTypes.func,
  renderShowMoreUpdatesLink: PropTypes.func,
  hideSheetTitle: PropTypes.bool,
  isLoading: PropTypes.bool,
  setCurrentUpdate: PropTypes.func,
  showLikeError: PropTypes.bool,
  setShowLikeError: PropTypes.func,
  showLoading: PropTypes.bool,
  isListError: PropTypes.bool,
  fetchOrganizerUpdates: PropTypes.func,
  fetchNextUpdates: PropTypes.func,
};
export default OrganizerUpdatesSheet;
